<template>
  <b-container>
    <b-modal id="error-modal" v-model="showError" hide-footer hide-header-close>
      <template #modal-title>
        <div class="text-center">
          <h4>{{ errorTitle }}</h4>
        </div>
      </template>
      <template #default>
        <p v-show="errorMessage.length > 0" class="my-4">
          {{ errorMessage }}
        </p>
        <div v-show="errorMessage.length == 0">
          <p>
            Please note new polling locations are getting added everyday.
            Check back here on Election Day, November 5th, for your favorite artist’s message!
          </p>
          <p v-show="earlyVoteSiteAvailable">
            If you're interested in early voting, head here:
            </br>to cast your early voting ballot!<br>
            <a :href="'https://www.google.com/maps/search/?api=1&query=' +earlyVoting.locationName+','+earlyVoting.line1+','+','+earlyVoting.city+','+earlyVoting.state+','+earlyVoting.zip" target="_blank">
              {{ earlyVoting.locationName }}
              <br>{{ earlyVoting.line1 }}
              {{ earlyVoting.line2 }}
              <br>{{ earlyVoting.city }}, {{ earlyVoting.state }}, {{ earlyVoting.zip }}
            </a>
          </p>
          <p>
            If you’re having any issues, contact <a href="mailto:support@drops.nyc">support@drops.nyc</a>
          </p><p>
            Polling locations are provided by<br><a href="https://www.votinginfoproject.org/election-coverage">The Voting Information Project</a>.
          </p>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="secondary" @click="showError = false">
          Wait for Election Day
        </b-button>
        <b-button variant="primary" :href="'https://www.google.com/maps/search/?api=1&query=' +earlyVoting.locationName+','+earlyVoting.line1+','+','+earlyVoting.city+','+earlyVoting.state+','+earlyVoting.zip" target="_blank">
          Go To Early Voting
        </b-button>
      </template>
    </b-modal>
    <!-- on desktop -->
    <b-container v-show="$device.isDesktop" class="text-center">
      <b-row align-h="center" align-v="center">
        <b-col class="col-lg-6">
          <img
            src="/images/DropsLogoSmal-ccl.gif"
            style="max-height: 100px;"
            alt="Drops"
          >
          <h3>
            DROPS
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-12">
          <h4>
            To view this drop you'll need to be on a mobile device.
          </h4>
          <p>Please click or scan this QR code on your phone or tablet</p>
          <a :href="dropUrl" target="_blank">
            <vue-qrcode
              v-if="dropUrl"
              :value="dropUrl"
              dark="#212529"
              class="qr-code"
            />
          </a>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-12">
          <a :href="dropUrl" target="_blank">
            {{ dropUrl }}
          </a>
        </b-col>
      </b-row>
    </b-container>
    <div v-show="$device.isMobileOrTablet && askForGeo && category === 'vote'">
      <b-container fluid class="d-flex flex-column min-vh-100">
        <b-row class="p-3 pt-5">
          <h3 class="text-center">
            Let's determine your polling location
          </h3>
          <div class="text-center">
            We value your privacy. This information is not stored anywhere.
          </div>
        </b-row>
        <b-row align-h="center" align-v="center">
          <b-col cols="12" class="col-lg-6">
            <div id="bg" class="w-100">
              <b-form v-show="category==='vote'" @submit.prevent="submitForm()">
                <b-form-group id="user-address">
                  <b-form-input
                    id="street"
                    v-model="street"
                    type="text"
                    name="street"
                    placeholder="Street"
                    required
                  />
                </b-form-group>
                <b-form-group id="user-city">
                  <b-form-input
                    id="city"
                    v-model="city"
                    type="text"
                    name="city"
                    placeholder="City"
                    required
                  />
                </b-form-group>
                <b-row>
                  <b-col>
                    <b-form-group id="user-state">
                      <b-form-select
                        id="state"
                        v-model="state"
                        :options="states"
                        name="state"
                        required
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="user-zip">
                      <b-form-input
                        id="zip"
                        v-model="zip"
                        type="text"
                        name="zip"
                        placeholder="Zip"
                        required
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-button type="submit" variant="primary" block>
                  Submit
                </b-button>
                <b-spinner
                  v-show="loading"
                  style="width: 3rem; height: 3rem"
                  variant="secondary"
                  label="Loading drop"
                  class="mt-5"
                />
              </b-form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- on mobile -->
    <div v-show="$device.isMobileOrTablet && askForGeo && category !== 'vote'">
      <b-container fluid class="d-flex flex-column min-vh-100 justify-content-center align-items-center">
        <div>
          <p class="text-center">
            <b>
              AR Hunt
            </b>
          </p>
          <p>
            An exclusive <b v-show="handle">{{ this.handle }}</b> Drop is nearby. Please share your Geolocation to see where it is located!
          </p>
          <b-button
            class="w-100 text-center"
            variant="dark"
            block
            @click="initGeofenceOK"
          >
            GO!
          </b-button>
        </div>
      </b-container>
    </div>
  </b-container>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import gtag from '~/plugins/gtagGA4.js'

export default {
  layout: 'media',
  components: {
    VueQrcode
  },
  asyncData ({ req, res }) {
    return {
      baseUrl:
        'https://' +
        (process.server ? req.headers.host : window.location.hostname)
    }
  },
  data () {
    return {
      debug: this.$route.query ? this.$route.query.debug : false,
      showError: false,
      errorTitle: 'Error',
      errorMessage: '',
      earlyVoteSiteAvailable: false,
      earlyVoting: {
        coords: [0, 0],
        locationName: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: ''
      },
      handle: this.$route.params.handle,
      category: this.$route.params.category.toLowerCase(),
      // creatorUser: null,
      next: this.$route.query && this.$route.query.next ? this.$route.query.next : 0,
      locationAllowed: false,
      loading: false,
      currentCoords: null,
      coordsInput: '',
      nearby: [],
      nearbyString: '',
      error: { message: '' },
      askForGeo: false,
      clonedDrop: {},
      watchId: null,
      gettingNearby: false,
      dropUrl: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      states: [
        'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
      ]
    }
  },
  mounted () {
    gtag()
    const savedData = localStorage.getItem(this.handle + ':nearbyData')
    this.dropUrl = `${this.baseUrl}/${this.handle}/go/${this.category}`
    debugger
    if (savedData) {
      this.nearby = JSON.parse(savedData)
      this.nearbyString = this.nearby
      if (!this.next) {
        this.next = 0
      }
      if (this.locationAllowed) {
        this.main()
      } else {
        this.askForGeo = true
      }
    } else {
      this.askForGeo = true
    }
  },
  methods: {
    resetEarlyVoting () {
      this.earlyVoteSiteAvailable = false
      this.earlyVoting = {
        coords: [0, 0],
        locationName: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: ''
      }
    },
    submitForm () {
      this.resetEarlyVoting()
      if (!this.street || !this.city || !this.state || !this.zip) {
        this.$toast.error('All fields are required.')
        return
      }
      this.loading = true
      debugger
      const formData = { address: this.street + ', ' + this.city + ', ' + this.state + ' ' + this.zip }
      this.$axios.post('/get-polling', formData)
        .then((response) => {
          debugger
          this.loading = false
          if (response.data.pollingLocations && response.data.pollingLocations.length > 0) {
            this.nearby[0] = {
              name: response.data.pollingLocations[0].name,
              location: {
                name: response.data.pollingLocations[0].name,
                lng: response.data.pollingLocations[0].coords[1],
                lat: response.data.pollingLocations[0].coords[0]
              }
            }
            this.main()
          } else if (response.data.earlyVoteSites && response.data.earlyVoteSites.length > 0) {
            this.earlyVoteSiteAvailable = true
            this.earlyVoting = {
              address: response.data.earlyVoteSites[0].address,
              locationName: response.data.earlyVoteSites[0].address.locationName,
              line1: response.data.earlyVoteSites[0].address.line1,
              line2: response.data.earlyVoteSites[0].address.line2,
              city: response.data.earlyVoteSites[0].address.city,
              state: response.data.earlyVoteSites[0].address.state,
              zip: response.data.earlyVoteSites[0].address.zip
            }
            this.errorTitle = 'Your election day polling location is not available yet'
            this.showError = true
          } else {
            this.errorTitle = 'Your polling location \n hasn\'t been added yet'
            this.showError = true
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.errorMessage = error.response.data.error
            this.loading = false
            this.showError = true
          } else {
            this.$toast.error('Failed to submit form. Please try again.')
          }
        })
    },
    initGeofenceOK () {
      debugger
      this.askForGeo = false
      this.locationAllowed = true
      this.initGeofence()
    },
    initGeofence () {
      debugger
      if ('geolocation' in navigator && this.locationAllowed) {
        this.loading = true
        this.watchId = navigator.geolocation.watchPosition(
          (position) => {
            this.loading = false
            this.currentCoords = {
              lon: position.coords.longitude,
              lat: position.coords.latitude
            }
            this.coordsInput = position.coords.longitude + ', ' + position.coords.latitude
            if (!this.gettingNearby) {
              this.getNearby(this.category)
            }
          },
          (err) => {
            // console.log(err.message)
            this.loading = false
            this.locationAllowed = false
            this.$toast.error(err.message, { autoHide: false })
          },
          { enableHighAccuracy: true, maximumAge: 0, timeout: 20000 }
        )
      } else {
        // console.log('Geolocation not available')
      }
    },
    async getNearby (category) {
      debugger
      if (this.watchId) { navigator.geolocation.clearWatch(this.watchId) }
      this.gettingNearby = true
      debugger
      // pass in categorys=park, grocery, school and get the results like that.
      if (!category || category === '') {
        const errMessage = 'Category type of point-of-interest is missing and required'
        this.$toast.error(errMessage, { duration: 10000 })
      } else {
        const response = await this.$axios.post('/get-nearby', { position: this.currentCoords, category }).then((response) => {
          this.nearby = response.data
          this.nearbyString = JSON.stringify(this.nearby)
          this.storeNearby(this.nearbyString)

          this.main()
        }).catch((error) => {
          debugger
          const errMessage = error.response.data.error
          this.$toast.error(errMessage)
        })
      }
    },
    main () {
      // TODO: creator could be different than this user's handle.
      // include a creator handle in the URL like: drops.nyc/cake/go/vote?creator=ivoted
      // or creator id in the url like drops.nyc/cake/go/vote?creator=5f7b3
      this.getCreatorId().then((response) => {
        const handleUser = response.data
        debugger
        // this.creatorUser = handleUser

        if (handleUser && handleUser.my_set) {
          // TODO CHECK IF THE DROP EXISTS ALREADY IN THE SET
          // BASED on the place.name and coordinates

          // CLONE DROP
          const newDrop = this.cloneDrop(handleUser.my_set._id, this.nearby[this.next], this.next).then((res) => {
            debugger
            this.clonedDrop = res.data
            const baseUrl = 'https://' + (process.server ? req.headers.host : window.location.hostname) + ':' + (process.server ? req.headers.port : window.location.port)

            if (this.clonedDrop.type === 'media') {
              window.location.href = baseUrl + '/m/' + this.clonedDrop._id
            } else if (this.clonedDrop.type === 'ar') {
              window.location.href = baseUrl + '/d/' + this.clonedDrop._id
            } else {
              this.$toast.error('hmm, the drop type seems to be missing.', { duration: 10000 })
            }
            // $router crashes server
            // setTimeout(() => this.$router.push({ path: '/d/' + this.clonedDrop._id }), 1000)
          }).catch((error) => {
            debugger
            const err = error.response.data
            if (err) {
              this.$toast.error(err.message, { duration: 10000 })
            }
          })
        }
      })
    },
    storeNearby (data) {
      if (process.client) {
        localStorage.setItem(this.handle + ':nearbyData', data)
      }
    },
    async cloneDrop (setId, place, index) {
      debugger
      return await this.$axios.post('/pub/drop/clone', { setId, place, index })
    },
    getCreatorId () {
      return this.$axios.get('/userhandle/' + this.handle)
    }
  }
}
</script>

<style scoped>
.bg-gradient{
  background: linear-gradient(-45deg, #869DE4,#4A2695, #4A2695, #869DE4);
  color: white;
}
</style>
